import { ProceduresParams } from '@/api/queries/procedures';
import { parseAsInteger, useQueryState } from 'nuqs';
import { createContext, useMemo, useState } from 'react';

type ActiveFilters = Pick<
  ProceduresParams,
  | 'humanReadableId'
  | 'eligibilityStatus'
  | 'procedureDate'
  | 'procedureStatus'
  | 'planningStatus'
>;

export interface TProceduresContext {
  page: number;
  setPage: (page: number) => Promise<URLSearchParams>;
  activeFilters: ActiveFilters;
  setActiveFilters: (filters: ActiveFilters) => void;
}

export const ProceduresContext = createContext<TProceduresContext>(
  {} as TProceduresContext,
);

export type TProceduresInitialData = Omit<
  TProceduresContext, 'setPage' | 'setActiveFilters'
>;

export const QueryStateKey = 'pr_page';

export function ProceduresProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [ page, setPage ] = useQueryState(QueryStateKey, parseAsInteger.withDefault(1).withOptions({
    history: 'push',
  }));
  const [ activeFilters, setActiveFilters ] = useState<ActiveFilters>({});

  const value = useMemo(() => {
    return { page, setPage, activeFilters, setActiveFilters };
  }, [ page, setPage, activeFilters, setActiveFilters ]);

  return (
    <ProceduresContext.Provider value={ value }>
      { children }
    </ProceduresContext.Provider>
  );
}
